/* eslint-disable import/no-anonymous-default-export */
import requestOptions from './requestOptions'
import Negocio_Mapper from '../models/Negocio_Mapper'
import apiValidation from '../validation/ApiRespValidation'

const getOrdenesService = async (page, perPage, parameters, businessModuleId, estadoPago, ordenId, search) => {
    try {
        const options = requestOptions.options('GET', parameters, '')
        const resp = await fetch(global.ORDENES + '/' + businessModuleId + '/' + page + '/' + perPage + '/' + estadoPago + '/' + ordenId + '/' + search, options)
        const data = await resp.json()
        let response
        if (ordenId > 0) {
            response = Negocio_Mapper.ordenesByIdMapper(data.data)
        } else {
            response = Negocio_Mapper.ordenesMapper(data.data)
        }
        return response
    } catch (error) {
        return apiValidation.apiError500()
    }
}

const saveComprobantePagoService = async (parameters, businessModuleId, ordenId, file, fechaPago) => {
    try {
        let totalSizeMB = file.size / (1024 * 1024)

        /*if (totalSizeMB > MAX_FILE_SIZE_MB) {
            return {
                "message": `El tamaño del archivo excede el límite permitido de ${MAX_FILE_SIZE_MB} MB.`,
                "error": true,
                "variant": "error"
            }
        }*/

        // Crear FormData para enviar el archivo
        const formData = new FormData()
        formData.append("businessModuleId", businessModuleId)
        formData.append("ordenId", ordenId)
        formData.append("ip", localStorage.getItem("ip"))
        formData.append("media", file)
        formData.append("fechaPago", fechaPago)

        const options = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${parameters}`
            },
            body: formData
        }

        const resp = await fetch(global.COMPROBANTE, options)
        const response = await resp.json()
        return response

    } catch (error) {
        console.error("Error al enviar el comprobante:", error)
        return apiValidation.apiError500()
    }
}

const saveOrdenConfirmLogicService = async (parameters, businessModuleId, ordenId, saveType, fechaPago) => {
    try {
        const body = {
            "businessModuleId": businessModuleId,
            "ordenId": ordenId,
            "ip": localStorage.getItem('ip'),
            "saveType": saveType,
            "fechaPago": fechaPago
        }
        const options = requestOptions.options('POST', parameters, body)
        const resp = await fetch(global.SAVE_ORDER_CONFIRM, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getOrdenesPendientesEnvioService = async (page, perPage, parameters, businessModuleId, ordenId, search) => {
    try {
        const options = requestOptions.options('GET', parameters, '')
        const resp = await fetch(global.ORDENES_PENDING_ENVIO + '/' + businessModuleId + '/' + page + '/' + perPage + '/no/' + ordenId + '/' + search, options)
        const data = await resp.json()
        let response
        if (ordenId > 0) {
            response = Negocio_Mapper.ordenesByIdMapper(data.data)
        } else {
            response = Negocio_Mapper.ordenesPendingSendMapper(data.data)
        }
        return response
    } catch (error) {
        return apiValidation.apiError500()
    }
}

const saveChangeTrackingService = async (userToken, moduleId, trackId, nuevoEstado, orderId) => {
    try {
        const body = {
            "businessModuleId": moduleId,
            "trackId": trackId,
            "orderId": orderId,
            "ip": localStorage.getItem('ip'),
            "estado": nuevoEstado
        }
        const options = requestOptions.options('POST', userToken, body)
        const resp = await fetch(global.SAVE_TRACK, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

export default {
    getOrdenesService,
    saveComprobantePagoService,
    saveOrdenConfirmLogicService,
    getOrdenesPendientesEnvioService,
    saveChangeTrackingService
}